import { isPlatformBrowser } from '@angular/common';
import { OrdersService } from './services/order/orders.service';
import { PdvService } from './services/pdv/pdv.service';
import { Component, OnInit, Inject, PLATFORM_ID, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  bsModalRef: BsModalRef;
  alert;
  @ViewChild("template") template: ElementRef;
  constructor(
    private router: Router,
    private pdvService: PdvService,
    private ordersService: OrdersService,
    private titleService: Title,
    private modalService: BsModalService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private meta: Meta
  ) {

  }
  compare(a, b) {
    if (a.level < b.level)
      return -1;
    if (a.level > b.level)
      return 1;
    return 0;
  }

  ngOnInit() {
    this.pdvService.getModesByPdv().subscribe(
      (data: any[]) => {
        this.pdvService.orderTypes.next(data);
        if (data.length > 0) {
          this.ordersService.orderType.next(data[0].id);
        }
      }
    );
    this.pdvService.getPdvInfo().subscribe(
      (data: any) => {
        this.pdvService.nbrOffersAuthorizedSite.next(data.nbrOffersAuthorizedSite);
        this.pdvService.pdv.next(data);
        this.ordersService.amountMiniDelivery.next(data.amountMiniOrder);
        this.ordersService.enablePayement.next(data.enablePayement);
        this.titleService.setTitle(data.name + " livre à domicile et au bureau");
        this.meta.addTag({ name: 'description', content: data.metaDescription });
        this.meta.addTag({ name: 'keywords', content: data.metaKeywords })
        if (isPlatformBrowser(this.platformId)) {
          if (data.alert) {
            this.alert = data.alert;
            this.bsModalRef = this.modalService.show(this.template, {
              class: "alert-modal"
            });
          }
        }
      }
    );
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      if (isPlatformBrowser(this.platformId)) {
        // (<any>window).ga('set', 'page', evt.urlAfterRedirects);
        // (<any>window).ga('send', 'pageview');
        window.scrollTo(0, 0);
      }
    });
  }

  // @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
  //   console.log("refresh")
  //   event.returnValue = false;
  // }
}
